import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AppImage, Skeleton } from '@/components';

import { externalLinks } from '@/config';

import iconTelegramColor from '@/assets/images/socials/logo-telegram-color.svg';
import iconMessengerColor from '@/assets/images/socials/logo-messenger-color.svg';

import { ModalInfo, ModalInfoProps } from '../ModalInfo';

import styles from './SocialsContactModal.module.sass';

interface SocialsContactModalProps extends ModalInfoProps {}

const SocialsContactModal: FC<SocialsContactModalProps> = (props) => {
  const { title, isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <ModalInfo
      isOpen={isOpen}
      title={title?.length ? title : t('translation.support_lnk')}
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.socials}>
        <a
          href={externalLinks.TELEGRAM_SUPPORT_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.social} ${styles.telegram}`}
        >
          <AppImage
            src={iconTelegramColor}
            alt="Telegram Icon"
            fallback={<Skeleton width={80} height={80} border="50%" />}
          />
          <span>Telegram</span>
        </a>
        {false && (
          <a
            href={externalLinks.MESSENGER_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.social} ${styles.messenger}`}
          >
            <AppImage
              src={iconMessengerColor}
              alt="Messenger Icon"
              fallback={<Skeleton width={80} height={80} border="50%" />}
            />
            <span>Messenger</span>
          </a>
        )}
      </div>
    </ModalInfo>
  );
};

export default SocialsContactModal;
